export default __webpack_public_path__ + "static/media/marker-default.e5e9eb47.svg";